<script>
    let url = '';
    
    export let only_one_cat = false;
    export let selector_catalog_element = '';
    export let selector_catalog_link = '';
    export let selector_catalog_title = '';
    export let selector_catalog_image = '';
    export let selector_catalog_image_outside = '';
    export let selector_catalog_description = '';
    export let selector_catalog_description_outside = '';

    export let change_url;
    export let find_selector;
</script>

<div class="section-title">Селекторы каталога</div>
<div class="wide-block pb-2">
    <div class="row">
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Адрес каталога</span>
                    <input type="url" class="form-control" placeholder="http://example.com/catalog" bind:value={url} on:change={() => change_url(url)}/>
                </div>
            </div>
        </div>
    
        <div class="col-12 text-center my-1">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" id="only_one_cat" bind:checked={only_one_cat} on:click={() => {only_one_cat = !only_one_cat}}>
                <label class="form-check-label" for="only_one_cat">Режим одной ветви</label>
            </div>
        </div>
        
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор элемента категории</span>
                    <input type="text" class="form-control" placeholder=".category" bind:value={selector_catalog_element} on:change={() => {find_selector(url, selector_catalog_element)}} />
                </div>
            </div>
        </div>
    
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор ссылки</span>
                    <input type="text" class="form-control" placeholder="a" bind:value={selector_catalog_link} on:change={() => {find_selector(url, selector_catalog_element + ' ' + selector_catalog_link)}} />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор заголовка</span>
                    <input type="text" class="form-control" placeholder="span.title" bind:value={selector_catalog_title} on:change={() => {find_selector(url, selector_catalog_element + ' ' + selector_catalog_title)}} />
                </div>
            </div>
        </div>
        
        <div class="col-12 mb-1">
            <div class="row" style="border-radius: 6px; border: 1px solid #0d6efd;">
                <div class="col-12">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <span>Селектор изображения</span>
                            <input type="text" class="form-control" placeholder="img" bind:value={selector_catalog_image} on:change={() => {find_selector(url, selector_catalog_element + ' ' + selector_catalog_image)}} />
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <span>[не в элементе]</span>
                            <input type="text" class="form-control" placeholder="img" bind:value={selector_catalog_image_outside} on:change={() => {find_selector(url, selector_catalog_image_outside)}} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="col-12">
            <div class="row" style="border-radius: 6px; border: 1px solid #0d6efd;">
                <div class="col-12">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <span>Селектор описания</span>
                            <input type="text" class="form-control" placeholder="p" bind:value={selector_catalog_description} on:change={() => {find_selector(url, selector_catalog_element + ' ' + selector_catalog_description)}} />
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <span>[не в элементе]</span>
                            <input type="text" class="form-control" placeholder="p" bind:value={selector_catalog_description_outside} on:change={() => {find_selector(url, selector_catalog_description_outside)}} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
